import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "../src/pages/Home";
import About from "../src/pages/About";
import Hero from "./components/Hero";

import Contact from "./components/Contact";

function App() {
  return (

    <BrowserRouter>

      <Routes>

        <Route path="/" element={<Home />} />

        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

      </Routes>

    </BrowserRouter>

  );
}

export default App;